// src/pages/DashboardPage.js

import React from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';

const DashboardPage = () => {
  return (
    <div className="flex">
      <Sidebar />
      <main className="flex-1 p-6 bg-gray-50 min-h-screen">
        <h1 className="text-2xl font-bold mb-4">Welcome to the Evaluator Dashboard</h1>
        <p className="text-gray-600">Use the sidebar to navigate and start evaluating orders.</p>
        <Footer />
      </main>
    </div>
  );
};

export default DashboardPage;
